<template>
  <div>
    <div class="top-banner">
      <div class="left">
        <img class="kefuicon" src="@/assets/image/kefu.png" />
        <div style="margin-left: 8px">客服服务时间：9 : 00 - 18 : 00</div>
      </div>
      <div class="right">
        <div class="underline" v-if="$route.path !== '/' || isLoggedIn" @click="goHome">首页</div>
        <div class="underline" style="margin-left: 48px" @click="showServiceDialog = true">客户服务</div>
        <div class="underline" style="margin-left: 48px" @click="goAbout">关于我们</div>
        <div class="login-btn" v-if="!isLoggedIn" @click="goLogin">登录</div>
        <div class="register-btn" v-if="!isLoggedIn" style="margin-left: 12px" @click="goRegister">注册</div>
        <div class="iconMessage-box" v-if="isLoggedIn" @click="showMessageDialog = true">
          <img class="iconMessage" src="@/assets/image/iconMessage.png" />
          <div class="show-dot" v-show="showDot"></div>
        </div>
        <el-popover v-if="isLoggedIn" popper-class="user-popovers" placement="bottom" width="180" trigger="hover">
          <div class="user-menu">
            <div class="menu-row" @click="goUserCenter('/user-center/info-manage')">
              <img class="menu-icon" src="@/assets/image/menuIcon5.png" />
              <span>信息查看与管理</span>
            </div>
            <div class="menu-row" @click="goUserCenter('/user-center/personal-info')">
              <img class="menu-icon" src="@/assets/image/menuIcon6.png" />
              <span>个人信息</span>
            </div>
            <div class="menu-row" @click="goUserCenter('/user-center/user-agreement')">
              <img class="menu-icon" src="@/assets/image/menuIcon2.png" />
              <span>用户协议</span>
            </div>
            <div class="menu-row" @click="goUserCenter('/user-center/privacy-agreement')">
              <img class="menu-icon" src="@/assets/image/menuIcon1.png" />
              <span>隐私协议</span>
            </div>
            <div class="menu-row" @click="goUserCenter('/user-center/complaint-suggestion')">
              <img class="menu-icon" src="@/assets/image/menuIcon7.png" />
              <span>投诉建议</span>
            </div>
            <div class="menu-row logout" @click="handleLogout">
              <img class="menu-icon" src="@/assets/image/menuIcon3.png" />
              <span>退出登录</span>
            </div>
          </div>
          <div slot="reference" class="avatar-wrapper">
            <img class="avatar" :src="avatarSrc" />
            <i class="el-icon-arrow-down" style="margin-left: 7px; font-size: 14px"></i>
          </div>
        </el-popover>
      </div>

      <el-dialog top="8vh" :append-to-body="true" :visible.sync="showServiceDialog" width="580px" :show-close="false" :close-on-click-modal="true" custom-class="kehufuwu">
        <CustomerService @close="showServiceDialog = false" />
      </el-dialog>

      <el-dialog top="8vh" :append-to-body="true" :visible.sync="showMessageDialog" width="1200px" :show-close="false" :close-on-click-modal="true" custom-class="message-dialog-wrap">
        <MessageDialog v-if="showMessageDialog" @close="showMessageDialog = false" />
      </el-dialog>
    </div>
    <div style="height: 60px"></div>
  </div>
</template>

<script>
import CustomerService from "./CustomerService.vue";
import MessageDialog from "./MessageDialog.vue";
import { getMessageUnreadStat } from "@/api/message";

export default {
  name: "TopBanner",
  components: {
    CustomerService,
    MessageDialog,
  },
  data() {
    return {
      showDot: false,
      showServiceDialog: false,
      showMessageDialog: false,
    };
  },
  computed: {
    isLoggedIn() {
      return !!localStorage.getItem("token");
    },
    avatarSrc() {
      const cached = JSON.parse(localStorage.getItem("userRes") || "{}");
      return cached.headPortrait || require("@/assets/image/avatar.png");
    },
  },
  mounted() {
    let isLogin = localStorage.getItem("token");
    if (isLogin) {
      this.getMessageUnreadStatFun();
    }
  },
  methods: {
    async getMessageUnreadStatFun() {
      const res = await getMessageUnreadStat();
      if (res.code == "200") {
        this.showDot = false;
        res.data.unreadItems.forEach((item) => {
          if (item.itemName == "platform") {
            if (item.itemValue != "0") {
              this.showDot = true;
            }
          }
          if (item.itemName == "purchase") {
            if (item.itemValue != "0") {
              this.showDot = true;
            }
          }
          if (item.itemName == "supplier") {
            if (item.itemValue != "0") {
              this.showDot = true;
            }
          }
        });
      } else {
        this.$message.error(res.msg);
      }
    },

    goHome() {
      if (this.isLoggedIn) {
        this.$router.push("/home");
      } else {
        this.$router.push("/");
      }
    },
    goLogin() {
      this.$router.push("/login");
    },
    goRegister() {
      this.$router.push("/register");
    },
    goAbout() {
      this.$router.push("/about");
    },
    goUserCenter(path) {
      this.$router.push(path);
    },
    handleLogout() {
      this.$confirm("确定要退出登录吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          localStorage.removeItem("token");
          localStorage.removeItem("role");
          this.$router.push("/");
          this.$message.success("退出成功");
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped>
.top-banner {
  width: 100%;
  line-height: 60px;
  background: #1869ff;
  display: flex;
  justify-content: space-around;
  font-size: 20px;
  color: #ffffff;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1;
}
.top-banner .left {
  display: flex;
  align-items: center;
}
.top-banner .right {
  display: flex;
  align-items: center;
}

.top-banner .kefuicon {
  width: 20px;
  height: 20px;
}

.top-banner .iconMessage-box {
  margin-left: 48px;
  width: 24px;
  height: 24px;
  line-height: normal;
  position: relative;
  cursor: pointer;
}

.top-banner .iconMessage {
  width: 100%;
  height: 100%;
}
/* .top-banner .iconMessage-box::after {
  display: block;
  content: "";
  position: absolute;
  right: 0;
  top: 0;
  width: 8px;
  height: 8px;
  background: none;
  border-radius: 50%;
} */

.top-banner .show-dot {
  background: #ff0000;
  position: absolute;
  right: -2px;
  top: 0;
  width: 8px;
  height: 8px;
  border-radius: 50%;
}

.top-banner .login-btn {
  padding: 0 17px;
  border-radius: 4px;
  border: 1px solid #ffffff;
  margin-left: 48px;
  line-height: 38px;
  cursor: pointer;
}

.top-banner .register-btn {
  line-height: 40px;
  padding: 0 30px;
  background: #1890ff;
  border-radius: 4px;
  cursor: pointer;
}

.top-banner .underline {
  line-height: normal;
  position: relative;
  cursor: pointer;
}

.top-banner .underline::before {
  content: "";
  display: block;
  position: absolute;
  width: 100%;
  height: 2px;
  left: 0;
  bottom: -10px;
  background: rgba(0, 0, 0, 0);
  transition: all 0.3s;
}

.top-banner .underline:hover::before {
  background: #ffffff;
}

/* 个人中心 */
.top-banner .avatar-wrapper {
  margin-left: 48px;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.top-banner .avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  object-fit: cover;
}

.user-popovers .user-menu {
  font-size: 16px;
  color: #000000;
  cursor: pointer;
}
.user-popovers .menu-row {
  height: 46px;
  line-height: 46px;
  font-weight: 400;
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-size: 16px;
  color: #000000;
  padding-left: 14px;
  transition: all 0.5s;
  display: flex;
  align-items: center;
}
.user-popovers .menu-row:hover {
  background-color: #f4f5f8;
}
.user-popovers .menu-icon {
  width: 20px;
  height: 20px;
  margin-right: 12px;
}
</style>

<style>
.message-dialog-wrap {
  border-radius: 20px;
}
.user-popovers {
  padding: 0;
  border-radius: 10px;
}

.kehufuwu {
  border-radius: 30px;
}
.kehufuwu .el-dialog__header {
  padding: 0;
}

.kehufuwu .el-dialog__body {
  padding: 0;
}
</style>
